import api from "./Api";

class GwayAgenteAtualizacaoService {
  GetConfiguracao() {
    return api
      .get("/v1/GwayAgenteAtualizacao/Configuracao")
      .then((response) => response.data);
  }

  PostRelease(payload) {
    return api
      .post("/v1/GwayAgenteAtualizacao/Release", payload)
      .then((response) => response.data);
  }

  PutRelease(payload) {
    return api
      .put("/v1/GwayAgenteAtualizacao/Release", payload)
      .then((response) => response.data);
  }

  DeleteRelease(payload) {
    return api
      .delete("/v1/GwayAgenteAtualizacao/Release/" + payload)
      .then((response) => response.data);
  }

  PublicarRelease(payload) {
    return api
      .post("/v1/GwayAgenteAtualizacao/Release/Publicar/" + payload)
      .then((response) => response.data);
  }

  UploadInstalador(payload) {
    return api
      .post("/v1/GwayAgenteAtualizacao/Release/UploadInstalador", payload)
      .then((response) => response.data);
  }

  PostArquivo(payload) {
    return api
      .post("/v1/GwayAgenteAtualizacao/Arquivo", payload)
      .then((response) => response.data);
  }

  PutArquivo(payload) {
    return api
      .put("/v1/GwayAgenteAtualizacao/Arquivo", payload)
      .then((response) => response.data);
  }

  DeleteArquivo(payload) {
    return api
      .delete("/v1/GwayAgenteAtualizacao/Arquivo/" + payload)
      .then((response) => response.data);
  }
}

export default new GwayAgenteAtualizacaoService();
